import React, { useState, useEffect, useRef } from 'react';
import { Link } from 'gatsby';
import { Logo } from '../components';
import { FiMenu, FiChevronDown, FiChevronRight } from 'react-icons/fi';
import path from 'path-browserify';

const Navbar = () => {
    const [isExpanded, toggleExpansion] = useState(false);
    const [activeDropdown, setActiveDropdown] = useState(null);
    const [windowWidth, setWindowWidth] = useState(0);
    const wrapperRef = useRef(null);
    const [activeMobileDropdown, setActiveMobileDropdown] = useState(null);

    useEffect(() => {
        const handleResize = () => {
            setWindowWidth(window.innerWidth);
        };

        if (typeof window !== 'undefined') {
            setWindowWidth(window.innerWidth); // Set initial window width
            window.addEventListener('resize', handleResize);
        }

        return () => {
            if (typeof window !== 'undefined') {
                window.removeEventListener('resize', handleResize);
            }
        };
    }, []);

    const navItems = [
        { name: 'Home', path: '/' },
        {
            name: 'Who We Are',
            path: '/who-we-are/',
            description: 'Holborn Assets is a leading international financial services with over 20,000 clients worldwide and in excess of $2billion AUM',
            children: [
                {
                    name: 'About Us',
                    path: '/who-we-are/about-us/',
                }, 
                {
                    name: 'Our People',
                    path: '/who-we-are/our-people/',
                },
                {
                    name: 'Holborn App',
                    path: '/who-we-are/introducing-the-holborn-app/',
                },
                {
                    name: 'Our Global Locations',
                    path: '/who-we-are/our-locations/',
                },
                {
                    name: 'News & Press',
                    path: '/who-we-are/news/',
                },
            ]
        },
        {
            name: 'Our Services',
            path: '/our-services',
            children: [
                {
                    name: 'Citizenship by Investment',
                    path: '/our-services/citizenship-by-investment/',
                },
                {
                    name: 'Estate Planning',
                    path: '/our-services/estate-planning/',
                },
                {
                    name: 'Financial Planning',
                    path: '/our-services/financial-planning/',
                },
                {
                    name: 'Investments',
                    path: '/our-services/investments/',
                },
                {
                    name: 'Retirement Planning',
                    path: '/our-services/retirement-planning/',
                },
                {
                    name: 'Wealth Management',
                    path: '/our-services/wealth-management/',
                },
            ]
        },
        { name: 'Insights', path: '/blog/' },
        { name: 'Webinars', path: '/webinars/' },
        { name: 'Get in touch', path: '/contact-us/' },
    ];

    return (
        <>
        <nav className="grid grid-cols-12 bg-white">
        <div className="col-start-2 col-span-10 lg:flex relative">
            <div className="flex justify-between items-center py-6 lg:flex lg:items-center lg:justify-between">
                <Link to='/'>
                    <Logo />
                </Link>
                <button onClick={() => toggleExpansion(!isExpanded)} className="block lg:hidden" aria-label="Menu">
                    <FiMenu size={32} className="text-black" />
                </button>
            </div>
            {(isExpanded || (typeof window !== 'undefined' && windowWidth > 1023)) && (
            <div className={`${isExpanded ? `opacity-100` : `opacity-0`} lg:opacity-100 transition-opacity duration-700 w-full block lg:flex lg:items-center lg:justify-end border-t-4 border-holborn-green lg:border-t-0 lg:mt-4 mb-4 lg:mt-0`}>
                <div className="relative text-sm lg:flex-grow flex flex-col lg:flex-row lg:justify-end" ref={wrapperRef}>
                    {navItems.map((item, index) => (
                        <div
                            className="relative group inline-block"
                            key={item.name}
                            onMouseEnter={() => (typeof window !== 'undefined' && windowWidth > 767) && setActiveDropdown(item.name)}
                            onMouseLeave={() => (typeof window !== 'undefined' && windowWidth > 767) && setActiveDropdown('')}
                            role="button"
                            tabIndex="0"
                        >
                            <Link 
                                to={item.path} 
                                className={`block py-2 px-4 xl:px-5 xl:py-3 2xl:px-7 xl:inline-block text-holborn-blue hover:bg-opacity-20 ${index !== navItems.length - 1 ? 'xl:hover:bg-transparent' : ''} xl:hover:text-holborn-mid-blue tracking-wider text-sm ${index === navItems.length - 1 ? 'lg:bg-holborn-green lg:text-white lg:rounded-3xl lg:ml-5 lg:hover:bg-holborn-blue xl:hover:text-white xl:transition-colors xl:duration-700' : ''}`}
                                onClick={(e) => {
                                    if(typeof window !== 'undefined' && windowWidth <= 767 && item.children) {
                                        e.preventDefault();
                                        setActiveMobileDropdown(activeMobileDropdown === item.name ? null : item.name);
                                    }
                                }}
                            >
                                <div className="flex justify-between items-center w-full">
                                    {item.name}
                                    {item.children && (
                                        <FiChevronDown className={` ml-2 transition-transform duration-200 ${activeDropdown === item.name ? 'transform rotate-180' : ''}`} />
                                    )}
                                </div>
                            </Link>
                            {item.children && ((typeof window !== 'undefined' && windowWidth > 767 && activeDropdown === item.name) || (typeof window !== 'undefined' && windowWidth <= 767 && activeMobileDropdown === item.name)) && (
                                <div
                                    className={`${windowWidth > 767 ? 'bg-gray-50 absolute top-full left-0' : 'bg-white'} py-2 w-64 ${windowWidth <= 767 ? 'pl-4' : ''}`}
                                    style={{ zIndex: 10 }}
                                >
                                    {item.children.map((child, index) => (
                                                    <div className={`${windowWidth > 767 ? 'px-4' : 'px-4'}`}>
                                                        <div className={`py-2 ${index < item.children.length - 1 && windowWidth > 767 ? 'border-b border-holborn-light-blue' : ''}`}>
                                                            <Link
                                                                key={index}
                                                                to={child.path}
                                                                className="block text-sm text-holborn-blue hover:bg-opacity-20 hover:text-holborn-mid-blue tracking-wider transition-colors duration-700 mb-2"
                                                                >
                                                                {windowWidth <= 767 && <FiChevronRight className="inline-block mr-2" />}
                                                                {child.name}
                                                            </Link>
                                                            {child.children && (
                                                                <div className="pl-4">
                                                                    {child.children.map((subChild, subIndex) => (
                                                                        <div key={subIndex} className="py-2">
                                                                            <Link
                                                                                to={subChild.path}
                                                                                className="block text-sm text-holborn-blue hover:bg-opacity-20 hover:text-holborn-mid-blue tracking-wider transition-colors duration-700"
                                                                            >
                                                                                <FiChevronRight className="inline-block" /> {subChild.name}
                                                                            </Link>
                                                                        </div>
                                                                    ))}
                                                                </div>
                                                            )}
                                                        </div>
                                                    </div>
                                                ))}
                                    </div>
                                )}
                            </div>
                        ))}
                    </div>
                </div>
                )}
            </div>
        </nav>
        </>
    );
}

export default Navbar;